import FrontPhoto from "../images/MA_FotoLinkedin_Front.png";

const aboutConfig = {
  photo: FrontPhoto,

  bio_i18n: {
    en: [
      "I grew up in Spain and never imagined my career would take me so far from home. Along the way, I've lived and worked in Spain, Portugal, the UK, Denmark, and the U.S., meeting incredible people who have shaped how I think about science, technology, and life.",
      "I didn't become a data scientist by studying computer science. I became one by trying to understand the human brain. That journey took me from psychology and neuroscience to machine learning, where I discovered that data is one of the most powerful tools for solving meaningful problems.",
      "Before transitioning into industry, I spent years as a neuroscience researcher, contributing to NIH-funded projects exploring how AI and brain data can improve early mental health diagnosis.",
      "Today, I build healthcare-focused AI and data solutions. I design reliable data pipelines and deploy machine learning models for clinical and biomedical data with real-world impact. More than anything, I'm driven by curiosity, meaningful human connections, and the belief that we're always capable of learning, growing, and improving lives together.",
    ],
    es: [
      "Crecí en España y nunca imaginé que mi carrera me llevaría tan lejos de casa. A lo largo del camino, he vivido y trabajado en España, Portugal, el Reino Unido, Dinamarca y los Estados Unidos, conociendo personas increíbles que han dado forma a cómo pienso sobre la ciencia, la tecnología y la vida.",
      "No me convertí en científico de datos estudiando informática. Me convertí en uno intentando entender el cerebro humano. Ese viaje me llevó desde la psicología y las neurociencias hasta el machine learning, donde descubrí que los datos son una de las herramientas más poderosas para resolver problemas con sentido.",
      "Antes de dar el salto a la industria, pasé años como investigador en neurociencias, contribuyendo a proyectos financiados por el NIH que exploraban cómo la IA y los datos cerebrales pueden mejorar el diagnóstico temprano de la salud mental.",
      "Hoy construyo soluciones de IA y datos enfocadas en salud. Diseño pipelines de datos fiables y despliego modelos de machine learning para datos clínicos y biomédicos con impacto real. Por encima de todo, me impulsa la curiosidad, las conexiones humanas significativas y la convicción de que siempre somos capaces de aprender, crecer y mejorar vidas juntos.",
    ],
  },

  // Two groups instead of one flat chronological list — a strict timeline
  // makes the AI master's (which comes *after* the PhD) read like a step
  // down. Grouping by track instead avoids that entirely: one cluster is
  // the neuroscience/psychology foundation, the other is the deliberate
  // later pivot into applied AI & data science.
  educationGroups: [
    {
      id: "edu-group-neuro",
      title_i18n: { en: "Neuroscience & Psychology Foundation", es: "Formación en Neurociencia y Psicología" },
      items: [
        {
          id: "edu-1",
          label_i18n: { en: "BA Psychology", es: "Grado en Psicología" },
          tooltip_i18n: {
            en: "University of Granada & University of Coimbra",
            es: "Universidad de Granada y Universidade de Coimbra",
          },
        },
        {
          id: "edu-2",
          label_i18n: { en: "MS Cognitive Neuroscience & Behavior", es: "Máster en Neurociencia Cognitiva y del Comportamiento" },
          tooltip_i18n: { en: "University of Granada", es: "Universidad de Granada" },
        },
        {
          id: "edu-3",
          label_i18n: { en: "MS Neuroscience & Pain", es: "Máster en Neurociencia y Dolor" },
          tooltip_i18n: { en: "University of Granada", es: "Universidad de Granada" },
        },
        {
          id: "edu-4",
          label_i18n: { en: "PhD Psychology & Cognitive Neuroscience", es: "Doctorado en Psicología y Neurociencia Cognitiva" },
          tooltip_i18n: {
            en: "University of La Laguna — Cum Laude, Extraordinary Doctorate Award",
            es: "Universidad de La Laguna — Cum Laude, Premio Extraordinario de Doctorado",
          },
        },
      ],
    },
    {
      id: "edu-group-ai",
      title_i18n: { en: "Applied AI & Data Science", es: "IA Aplicada y Ciencia de Datos" },
      items: [
        {
          id: "edu-5",
          label_i18n: { en: "MS Artificial Intelligence & Data Science", es: "Máster en Inteligencia Artificial y Ciencia de Datos" },
          tooltip_i18n: {
            en: "European University of Madrid — Health Data Science specialization",
            es: "Universidad Europea — Especialización en Ciencia de Datos en Salud",
          },
        },
      ],
    },
  ],

  availability_i18n: {
    en: [
      { id: "avail-1", title: "Consulting Projects", desc: "Data, ML & AI engagements", icon: "briefcase" },
      { id: "avail-2", title: "Full-time Roles", desc: "US-based or remote from the US", icon: "badge" },
    ],
    es: [
      { id: "avail-1", title: "Proyectos de consultoría", desc: "Proyectos de datos, ML e IA", icon: "briefcase" },
      { id: "avail-2", title: "Posiciones de tiempo completo", desc: "En EEUU o remoto desde EEUU", icon: "badge" },
    ],
  },

  // ISO numeric codes for react-simple-maps world-atlas (west → east)
  collaboratorCountries: [
    { id: "col-us", iso: "840", name: "United States",  nameEs: "Estados Unidos" },
    { id: "col-co", iso: "170", name: "Colombia",       nameEs: "Colombia"       },
    { id: "col-br", iso: "076", name: "Brazil",         nameEs: "Brasil"         },
    { id: "col-gb", iso: "826", name: "United Kingdom", nameEs: "Reino Unido"    },
    { id: "col-pt", iso: "620", name: "Portugal",       nameEs: "Portugal"       },
    { id: "col-es", iso: "724", name: "Spain",          nameEs: "España"         },
    { id: "col-de", iso: "276", name: "Germany",        nameEs: "Alemania"       },
    { id: "col-dk", iso: "208", name: "Denmark",        nameEs: "Dinamarca"      },
    { id: "col-it", iso: "380", name: "Italy",          nameEs: "Italia"         },
    { id: "col-ro", iso: "642", name: "Romania",        nameEs: "Rumanía"        },
    { id: "col-in", iso: "356", name: "India",          nameEs: "India"          },
    { id: "col-cn", iso: "156", name: "China",          nameEs: "China"          },
  ],
};

export default aboutConfig;
